// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JdJT","content":"styles_content__3Ktyw","tableWrap":"styles_tableWrap__oJrnX"};